export function resolveGeofenceDeleteOperation({
  isPolygonal,
  geoClass,
  geoKey,
}) {
  void geoClass;

  if (typeof geoKey !== "string" || geoKey.trim() === "") {
    return null;
  }

  if (isPolygonal) {
    return {
      eventName: "delete_poli",
      args: [geoKey.trim()],
      successText: "Geocerca poli borrada",
    };
  }

  return null;
}

function pointToTuple(point) {
  if (Array.isArray(point) && point.length >= 2) {
    return [point[0], point[1]];
  }

  if (point && typeof point.lat === "function" && typeof point.lng === "function") {
    return [point.lat(), point.lng()];
  }

  if (point && typeof point.lat === "number" && typeof point.lng === "number") {
    return [point.lat, point.lng];
  }

  return [undefined, undefined];
}

function getPathLength(path) {
  if (!path) {
    return 0;
  }

  if (typeof path.getLength === "function") {
    return path.getLength();
  }

  if (Array.isArray(path)) {
    return path.length;
  }

  return 0;
}

function getPathPoint(path, index) {
  if (path && typeof path.getAt === "function") {
    return pointToTuple(path.getAt(index));
  }

  if (Array.isArray(path)) {
    return pointToTuple(path[index]);
  }

  return [undefined, undefined];
}

export function removeSelectedPolygonFromMap(polygons, selectedPoints) {
  const safePolygons = Array.isArray(polygons) ? polygons : [];
  const [selectedLat, selectedLng] = pointToTuple(
    Array.isArray(selectedPoints) ? selectedPoints[0] : null
  );

  if (typeof selectedLat !== "number" || typeof selectedLng !== "number") {
    return safePolygons;
  }

  return safePolygons.filter((polygon) => {
    const path =
      polygon && typeof polygon.getPath === "function"
        ? polygon.getPath()
        : polygon && polygon.path;
    let matchesSelectedPolygon = false;

    for (let index = 0; index < getPathLength(path); index++) {
      const [lat, lng] = getPathPoint(path, index);
      if (lat === selectedLat && lng === selectedLng) {
        matchesSelectedPolygon = true;
        break;
      }
    }

    if (matchesSelectedPolygon && polygon && typeof polygon.setMap === "function") {
      polygon.setMap(null);
    }

    return !matchesSelectedPolygon;
  });
}
